import React, { Component } from 'react';
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'
import { Chart } from "react-google-charts";

import UserProgressApi from '../../../api/UserProgressApi'

class OverallCategoryMistakes extends Component {
  constructor(props) {
    super(props)
    this.state = {data: []}
  }

  componentDidMount() {
    UserProgressApi.fetchCategoryOverallScore(this.props.user.id)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }
  render() {
    if(this.props.loading) {return <Loading />}

    const chart = (
      <Chart
        chartType="ColumnChart"
        data={this.state.data}
        width={'100%'}
        options={{
          title: 'Category Wise Mistakes (Overall)',
          chartArea: { width: '60%' },
          isStacked: true,
          "vAxis": {
            "title": "Percentage(%)",
            minValue: 0,
            maxValue: 100,
            viewWindow: {
              min: 0,
              max: 100
            }
          },
          "hAxis": {"title": "Categories"},
        }}
      />
    )

    return chart
  }
}

export default asyncWrapper(OverallCategoryMistakes)


// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/Scores/OverallCategoryMistakes.jsx